import { render, staticRenderFns } from "./BulletList.vue?vue&type=template&id=387d3253&"
import script from "./BulletList.vue?vue&type=script&lang=js&"
export * from "./BulletList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports